{
    "UsersList_Column_FullName": "Full name",
    "UsersList_Column_Username": "Username",
    "UsersList_Column_LockOut": "Locked out",
    "UsersList_LastLogon_None": "No data",
    "UsersList_Column_UserType": "User Type",
    "UsersList_Column_TelSys": "Telephony server",
    "UsersList_LockOut_Yes": "Yes",
    "UsersList_LockOut_No": "No",
    "UsersList_Filter_UserType_Label": "User type",
    "UsersList_UserType_All": "All",
    "UsersList_UserType_ServiceWide": "[Application-Wide Users]",
    "UsersList_UserType_SystemWide": "[Telephony-Wide Users]",
    "UsersList_UserType_Detached": "[Unattached Users]",
    "UsersList_UserType_AdminInclusive": "Administrative Users",
    "UsersList_UserType_AdminExclusive": "Non-Administrative Users",
    "UsersList_UserType_ReportingHistoricOnly": "Akixi Lite Users",
    "UsersList_UserType_ReportingBLF": "Akixi Presence Users",
    "UsersList_UserType_ReportingStd": "Akixi 1000 Users",
    "UsersList_UserType_ReportingACD": "Akixi 2000 Users",
    "UsersList_UserType_ReportingMobileAppAdvanced": "Enhanced Mobile Reporting Users",
    "UsersList_UserType_SignedInNow": "Signed-In Now",
    "UsersList_UserType_SignedInToday": "Signed-In Today",
    "UsersList_UserType_SignedInThisWeek": "Signed-In This Week",
    "UsersList_UserType_SignedInThisMonth": "Signed-In This Month",
    "UsersList_UserType_SignedInNever": "Never Signed-In",
    "UsersList_UserType_ActivityToday": "Activity Today",
    "UsersList_UserType_ActivityThisWeek": "Activity This Week",
    "UsersList_UserType_ActivityThisMonth": "Activity This Month",
    "UsersList_UserType_ActivityNone": "No Activity",
    "UsersList_CopyReports_Button": "Copy reports to",
    "UsersList_BulkAdd_Button": "Bulk Add",
    "UsersList_SignInAs_Button": "Sign in as",
    "UsersList_SignInAs_Confirm": "Sign in as **{}**? You will continue as that user in this browser session.",
    "UsersList_CopyReports_Dialog_Title": "Copy reports from **{} ({})**",
    "UsersList_CopyReports_Step_Reports": "Reports",
    "UsersList_CopyReports_Step_Targets": "Target users",
    "UsersList_CopyReports_Step_Confirm": "Confirm",
    "UsersList_CopyReports_Intro_Reports": "Select one or more reports to copy from **{}**.",
    "UsersList_CopyReports_Intro_Targets": "Select one or more users who should receive copies of those reports.",
    "UsersList_CopyReports_Confirm_Summary": "You will copy **{}** report(s) to **{}** user(s).",
    "UsersList_CopyReports_Confirm_Report_Label": "Copying **{}** report:",
    "UsersList_CopyReports_Confirm_Reports_Label": "Copying **{}** reports:",
    "UsersList_CopyReports_Confirm_Target_Label": "To **{}** user:",
    "UsersList_CopyReports_Confirm_Targets_Label": "To **{}** users:",
    "UsersList_CopyReports_Overwrite_Label": "Replace existing reports on target users when names conflict",
    "UsersList_CopyReports_Success": "Reports copied successfully.",
    "UsersList_CopyReports_Cancel": "Cancel",
    "UsersList_CopyReports_Back": "Back",
    "UsersList_CopyReports_Next": "Next",
    "UsersList_CopyReports_Copy": "Copy reports",
    "UsersList_CopyReports_Column_Folder": "Folder",
    "UsersList_CopyReports_Column_ReportName": "Report",
    "UsersList_CopyReports_Column_Type": "Type",
    "UsersList_CopyReports_Column_Username": "Username",
    "UsersList_CopyReports_Column_FullName": "Full name",
    "UsersList_CopyReports_Empty_Reports": "There are no reports available to copy for this user.",
    "UsersList_CopyReports_Empty_Targets": "There are no eligible target users in scope for this copy operation.",
    "UsersList_UserType_EptAccess": "Enhanced Provisioning Tool Access Users",
    "UsersList_UserType_CxIntegration": "CX Integration Users",
    "UsersList_UserType_ReportingPersonalDashboard": "Akixi ONE Users",
    "UsersList_UserType_ReportingOmni": "Akixi 3000 Users",
    "UsersList_Filter_Licence_Label": "Licence",
    "UsersList_Filter_Activity_Label": "Activity",
    "UsersList_Filter_LockedOut_Label": "Locked out",
    "UsersList_LockedOut_Any": "Any",
    "UsersList_LockedOut_Yes": "Locked out",
    "UsersList_LockedOut_No": "Not locked out",
    "UsersList_Filter_PendingDeletion_Label": "Pending deletion",
    "UsersList_PendingDeletion_Any": "Any",
    "UsersList_PendingDeletion_Only": "Pending Deletion Users",
    "UsersList_PendingDeletion_Excluded": "Exclude Pending Deletion Users",
    "UsersList_PendingDeletion_Tag": "Pending deletion",
    "UsersList_Restore_Button": "Restore",
    "UsersList_Restore_Confirm": "Do you wish to restore the application user **{}**?",
    "UsersList_Restore_ConfirmMany": "Do you wish to restore the **{}** selected application users?",
    "UsersList_Delete_MixedPendingDeletion": "Cannot delete users with 'Pending deletion' status and active users - all users must have the same state.",
    "UsersList_Filter_SelectedCount": "|1 selected",
    "UsersList_Column_Activity": "Activity",
    "UsersList_Column_LastSignedIn": "Last Signed In",
    "UsersList_Column_ActiveSignIns": "Active Sign-Ins",
    "UsersList_MoreInfo_Aria": "Show this user's activity totals",
    "UsersList_MoreInfo_LastSignedInAt": "Last Signed In At",
    "UsersList_MoreInfo_TotalTimesSignedIn": "Total Times Signed In",
    "UsersList_MoreInfo_ActiveSignInsNow": "Active Sign-Ins Now",
    "UsersList_MoreInfo_ActiveReportsLoaded": "Active Reports Loaded",
    "UsersList_MoreInfo_ActiveReportsRunningNow": "Active Reports Running Now",
    "UsersList_MoreInfo_LastScheduleRan": "Last Schedule Ran",
    "UsersList_MoreInfo_TotalSchedulesRun": "Total Schedules Run",
    "UsersList_MoreInfo_SchedulesConfiguredTotal": "Schedules Configured (Total)",
    "UsersList_MoreInfo_SchedulesConfiguredActive": "Schedules Configured (Active)",
    "UsersList_MoreInfo_InvalidPasswordAttemptsCurrent": "Invalid Password Attempts (Current)",
    "UsersList_MoreInfo_InvalidPasswordAttemptsTotal": "Invalid Password Attempts (Total)",
    "UsersList_MoreInfo_RestApiReportDataRequestsCount": "REST API Report Data Requests Count",
    "UsersList_MoreInfo_Never": "[Never]",
    "UsersList_MoreInfo_Loading": "Loading...",
    "UsersList_MoreInfo_Unavailable": "Activity totals are unavailable.",
    "NAME": "UsersListLanguage"
}
